import { type DateType, useAppTheme, useIntl } from '@capsicum/common';
import { WCPledgeStatus } from '@capsicum/features/world-championship-pledge/shared';
import { useMemo } from 'react';

export type WCPledgeCardRibbonColor = {
	backgroundColor: string;
};

export const useWCPledgeRibbonProperties = (status: WCPledgeStatus, endDate?: DateType | null) => {
	const { $t } = useIntl();
	const { theme } = useAppTheme();

	const ribbonColor = useMemo(
		() => ({
			closed: theme.colors.backgrounds.main.subtle,
			opened: theme.colors.backgrounds.info.subtle
		}),
		[theme.colors]
	);

	const ribbonText = useMemo(
		() =>
			endDate
				? $t('worldChampionshipPledge.entryPoint.cardRibbonTimerPrefix')
				: status === WCPledgeStatus.OPENED
					? $t('worldChampionshipPledge.entryPoint.cardRibbonOpened')
					: $t('worldChampionshipPledge.entryPoint.cardRibbonClosed'),
		[status, $t]
	);

	return {
		endDate,
		shouldShowTimer: !!endDate,
		WCPledgeCardRibbonColor: ribbonColor[status],
		WCPledgeCardRibbonText: ribbonText
	};
};
